import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { HttpService } from './http.service';
import 'rxjs/add/operator/map';
import { Observable, Subject } from 'rxjs';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';//debug
import 'rxjs/add/operator/catch';
import { ImageState } from '../_data-model/image';
import { config } from '../../../providers/config';
import { UtilService } from './util.service';

@Injectable()
export class LoginService {
  loginUrl = `/login`;
  sendEmailUrl = `/resetPassword?email=`;
  checkResetLinkUrl = `/checkResetLinkExpiry/`;
  setNewPasswordUrl = `/changePwd`;
  createNewPasswordUrl = `/updatePassword/`;
  signOutUrl = '/signout';

  private imageSubject = new Subject<ImageState>();
  imageState = this.imageSubject.asObservable();
  constructor(private http: HttpService, private utilService: UtilService) { }

  /* Service to login in application */

  login(model) {
    let body = `username=${encodeURIComponent(model.value.username)}&password=${encodeURIComponent(model.value.password)}`;
    return this.http.post(this.loginUrl, body)
      .map(res => {
        let data = res.json();
        if (data && data.responseObj && data.responseObj.token) {
          localStorage.setItem('loggedInUser', JSON.stringify(data.responseObj));
          console.log(data.responseObj.token);
        }
        return data;
      })
      .catch(this.utilService.handleError);
  }

  /* Service to Send email to backend for link */
  sendEmail(email): Observable<any> {
    return this.http.get(this.sendEmailUrl + email)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  /* Service to check valid email  */
  checkStatus(userId, token): Observable<any> {
    return this.http.get(this.checkResetLinkUrl + userId + '/' + token)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  /* Service to Set new password for firsttime loggin in user */
  setNewPassword(userId, model): Observable<any> {
    let body = { 'userId': userId, 'oldPwd': model.value.password, 'newPwd': model.value.passwords.password_confirm };

    return this.http.post(this.setNewPasswordUrl, body)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  /* Service to Create new password from email link */
  createNewPassword(userId, model): Observable<any> {
    return this.http.get(this.createNewPasswordUrl + userId + '/' + model.value.password_confirm)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  
profileInfo(url): any {
    this.imageSubject.next(<ImageState>{ imageSrc: url });
  }
  /* Service to logout from application and clear session */
  logout(): Observable<any> {
    return this.http.get(this.signOutUrl)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/_services/login.service.ts